/**
 * @desc 根据产品类型编号查询
 */
const URL = "/rantion-basics";
import http, { updateResponse } from "@/http";
export type Response = defs.basics.ResponseDto<defs.basics.ProductTypeResponseDto>;
export function request(typeNo: string, options?: any): Promise<Response> {
  return updateResponse(
    http(URL + `/basics/productType/byUnique/${typeNo}`, {
      method: "GET",

      ...options,
    }),
  );
}
